export const LOAD_PREFERENCES = 'LOAD_PREFERENCES';
export const LOAD_PREFERENCES_SUCCESS = 'LOAD_PREFERENCES_SUCCESS';
export const LOAD_PREFERENCES_ERROR = 'LOAD_PREFERENCES_ERROR';